import { styled } from '../../Utilities';
import { AnnouncedBase } from './Announced.base';
import { getStyles } from './Announced.styles';
export var Announced = styled(AnnouncedBase, getStyles);
//# sourceMappingURL=Announced.js.map